<template>
<div v-show="isShow" style="position:absolute; right:40px; bottom:65px;">
  <div class="action-progress" v-for="task in actionTasks" :key="task.taskName">
    <el-tooltip class="item" effect="dark" :content="getTooltip(task)" placement="left-start">
      <div class="alarm-progress setting">
        <span class="w-icon" :style="getProgressIconStyle(task)" @click="onIconClick(task)"><i class="fas fa-cog c-pointer"></i></span>
      </div>
    </el-tooltip>
    <el-progress class="settings" type="circle" :color="getProgressColor(task)" :percentage="task.progressRate"></el-progress>
  </div>
  <w-modeling-result-popup ref="networkModelingPopup"></w-modeling-result-popup>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import slice from 'lodash/slice';
import WModelingResultPopup from '@/views/settings/basic/DeviceRegistration/Network/popup/ModelingResultPopup';

export default {
  name: 'WActionProgress',
  components: { WModelingResultPopup },
  computed: {
    /**
     * 기능 수행 Task 배열
     * @author Ju
     * @return {Array}
     */
    actionTasks() {
      return isEmpty(this.$store.state.action.actionTasks) ? [] : slice(this.$store.state.action.actionTasks, 0, 3);
    },
    /**
     * 기능 수행 프로그레스 화면 표시 여부
     * @author Ju
     * @return {Boolean} [description]
     */
    isShow() {
      return !isEmpty(this.actionTasks);
    },
  },
  methods: {
    /**
     * Task 프로그레스 아이콘 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} task [description]
     * @return {[type]}      [description]
     */
    onIconClick(task) {
      if (task.isComplete && !task.autoComplete) {
        task.completeAction();
      } else if (!isEmpty(task.params.scanIds) && task.processName === '네트워크 모델링') {
        // (SK반영) 네트워크 마법사를 통해 모델링 시 프로그래스 아이콘 클릭 - 모델링 진행 팝업 제공 및 강제종료 기능 추가
        this.$refs.networkModelingPopup.open(task);
      }
    },
    /**
     * Task 프로그레스 아이콘 스타일을 반환한다.
     * @author Ju
     * @param  {[type]} task [description]
     * @return {[type]}      [description]
     */
    getProgressIconStyle(task) {
      const cursor = task.isComplete && !task.autoComplete ? 'pointer' : 'default';
      return { cursor };
    },
    /**
     * * Task 프로그레스 색상을 반환한다.
     * @author Ju
     * @param  {[type]} task [description]
     * @return {[type]}      [description]
     */
    getProgressColor(task) {
      return task.isComplete ? '' : '#ff9c89';
    },
    getTooltip(task) {
      return task.isComplete ? `${task.getProcessName()} 완료` : `${task.getProcessName()} 수행 중.. (${task.getProgressRate()}%)`;
    },
  },
};
</script>

<style lang="scss">
.action-progress {
  position: relative;
  margin-top: 10px;

  & > .alarm-progress.setting {
    position: relative;
    bottom: 0;
    right: 0;
  }

  & > .alarm-progress.setting > .w-icon {
    cursor: default;
  }

  & > .alarm-progress.setting > .w-icon.complete {
    cursor: pointer;
  }

  & > .el-progress {
    position: absolute;
    bottom: -2px;
    right: -2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/progressbar/ActionProgress.vue